<template>
    <v-card>
        <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="6" sm="6" md="6">
                        <DatePicker
                        v-model="newDate"
                        label="Date"
                        :default-date="newDate"
                        />
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-text-field
                            v-model="newAmount"
                            label="Amount"
                            prefix="$"
                            type="number"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-select
                            v-model="newType"
                            label="Type"
                            :items="type"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-select
                            v-model="newCategory"
                            label="Category"
                            :items="category"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" v-if="newCategory === 'Other'">
                        <v-text-field label="Other" v-model="newOther"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field label="Payee" v-model="newPayee"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-textarea
                            v-model="newDescription"
                            label="Description"
                            outlined
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-file-input
                            v-model="newReceipt"
                            class="pa-2"
                            label="Receipt"
                            filled
                            multiple
                            prepend-icon="mdi-camera"
                            accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            @change="fileSelected"
                            show-size
                        >
                            <template #selection="{ text, index }">
                                <v-chip
                                    small
                                    label
                                    close
                                    color="primary"
                                    @click:close="deleteChip(index)"
                                >{{ text }}
                                </v-chip
                                >
                            </template>
                        </v-file-input>
                    </v-col>
                    <v-col cols="12" v-for="doc in newReceipt" :key="doc.id">
                        <div v-if="doc.ext !== 'pdf'">
                            <v-img
                                max-height="480"
                                max-width="550"
                                :src="doc.aws"
                            ></v-img>
                        </div>
                        <div v-if="doc.ext === 'pdf'">
                            <load-pdf :pdfFile="doc.aws" :id="doc.id"/>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-checkbox
                            @click="addSignature()"
                            v-model="checkSignature"
                            label=" Staff Signature"
                        ></v-checkbox>
                        <v-expand-transition>
                            <v-text-field
                                v-if="checkSignature"
                                v-model="newSignature"
                                readonly
                            ></v-text-field>
                        </v-expand-transition>
                    </v-col>
                    <v-col cols="12">
                        <span>Has this been paid?</span>
                        <v-switch label="Yes" v-model="status" value="Paid"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-checkbox
                            @click="addManagerSignature()"
                            v-model="checkManagerSignature"
                            label=" Manager Signature"
                        ></v-checkbox>
                        <v-expand-transition>
                            <v-text-field
                                v-if="checkManagerSignature"
                                v-model="newManagerSignature"
                                readonly
                            ></v-text-field>
                        </v-expand-transition>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                fab
                small
                @click="showPrint()"
                class="mr-8 mb-2 white--text"
                color="#2b6993"
                elevation="4"
                v-if="viewingReimbursement"
            >
                <v-icon>print</v-icon>
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="updateReimbursement()"
                v-if="viewingReimbursement"
            >Update
            </v-btn>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import axios from "axios";
import moment from "moment";
// import Foot from '../components/Footer'
import LoadPdf from "@/components/LoadPDF.vue";
import {ROLES as Roles} from "@/enums/RolesEnum";
import {STATUS_ARRAY, STATUSES as UserStatus} from "../enums/UserStatusEnum";
import {STATUSES as StaffStatus} from "../enums/StaffStatusEnum";
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import PrintUtil from "../../utils/print-util";

const url = require("../client_config/config").url;

export default {
    components: {
        DatePicker,
        LoadPdf,
    },
    data: () => ({
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        menu: false,
        employees: [],
        expenses: [],
        startDate: "",
        endDate: "",
        StaffID: "",
        calendarMenu: false,
        calendar2Menu: false,
        report: "",
        clientName: "",
        isLoading: false,
        requiredField: [(v) => !!v || "This is required"],
        userState: localStorage.getItem('userState'),
        type: ["Cash", "Debit Card", "Deposit"],
        titleForm: "New Reimbursement",
        newDate: "",
        newAmount: "",
        newType: "",
        newCategory: "",
        newOther: "",
        newPayee: "",
        newBalance: "",
        newDescription: "",
        newReceipt: [],
        category: ["Client Purchase", "Mileage", "Reimbursement", "Other"],
        newEnteredBy: "",
        newManager: "",
        editReimbursement: false,
        newReimbursement: false,
        checkManagerSignature: false,
        checkSignature: false,
        managerSigned: false,
        newSignature: "",
        newManagerSignature: "",
        status: "Outstanding",
        staff: localStorage.getItem("Name"),
        token: localStorage.getItem('token'),
        msg: false,
        text: "",
        AWSLink: "",
        filterState: "",
        States: ["Utah", "Nevada"],
        staffStatus: "",
        staffStatuses: STATUS_ARRAY,
        viewingReimbursement: false
    }),

    computed: {
        minEndDate() {
            return this.startDate ? this.startDate : null;
        },
        showState() {
            if (
                // this.$store.state.users.userRole === Roles.ADMINISTRATION ||
                this.$store.state.users.userRole === Roles.SUPER_ADMINISTRATOR
            ) {
                return true;
            }
            return false;
        },

        filteredEmployees() {
            const employees = this.employees;

            if (this.staffStatus === UserStatus.INACTIVE) {
                return employees.filter(
                    (employee) => employee.Status === StaffStatus.TERMINATED
                );
            }

            if (this.staffStatus === UserStatus.ACTIVE) {
                return employees.filter(
                    (employee) =>
                        employee.Status === StaffStatus.FULL_TIME ||
                        employee.Status === StaffStatus.PART_TIME
                );
            }
            return employees;
        },
    },

    created() {
        this.viewingReimbursement = this.$route.query.viewingReimbursement === 'true';
        this.reimbursementId = this.$route.params.id;
        this.getEmployees();
    },

    mounted() {
        if (this.viewingReimbursement) {
            this.getExpense();
        }

        window.addEventListener('keydown', async (event) => {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, downloadUrl, this.reimbursementId, this.token, 'Reimbursement');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.reimbursementId, this.token, 'Reimbursement');
        });
    },

    methods: {
        initialize() {
            this.tests = [];
        },

        getEmployees() {
            let endpoint = "";
            const companyIds = localStorage.getItem("userCompanies");

            endpoint = `${url}/users/getAll/users/${this.state}`;

            axios
                .get(endpoint, {
                    params: {
                        Company: JSON.parse(companyIds),
                    },
                })
                .then((res) => {
                    this.employees = res.data.users;
                });

            // axios.get(`${url}/users/state/${this.state}`).then(async res => {
            //   this.employees = res.data.users;

            // });
        },
        close() {
           this.$router.go(-1);
            this.clear();
        },

        clear() {
            this.newDate = "";
            this.newAmount = "";
            this.newType = "";
            this.newCategory = "";
            this.newOther = "";
            this.newPayee = "";
            this.newBalance = "";
            this.newDescription = "";
            this.newReceipt = [];
            this.newSignature = "";
            this.newManagerSignature = "";
            this.checkSignature = false;
            this.checkManagerSignature = false;
        },

        getExpense() {
            this.expense = {};
            this.isLoading = true;
            this.userState = this.userState || '';

            let endpoint = "";

            endpoint = `${url}/reimbursements/${this.reimbursementId}`;

            axios
                .get(endpoint)
                .then((res) => {
                    this.expense = res.data;
                    this.viewReimbursement(this.expense);
                    this.isLoading = false;
                });
        },

        getStaffID(item) {
            this.staff = item.EmployeeID;
            window.localStorage.setItem("staffId", this.staff);
            console.log(this.staff);
        },

        viewReimbursement(item) {
            item.reimbursement.EnteredBy !== ""
                ? (this.checkSignature = true)
                : (this.checkSignature = false);
            item.reimbursement.Manager !== ""
                ? (this.checkManagerSignature = true)
                : (this.checkManagerSignature = false);
            this.titleForm = "Viewing " + item.reimbursement.Category;
            this.newDate = moment(item.reimbursement.Date).format("YYYY-MM-DD");
            this.newAmount = item.reimbursement.Amount;
            this.newType = item.reimbursement.Type;
            this.newCategory = item.reimbursement.Category;
            this.newOther = item.reimbursement.Other;
            this.newPayee = item.reimbursement.Payee;
            this.newBalance = item.reimbursement.Balance;
            this.newDescription = item.reimbursement.Description;
            this.status = item.reimbursement.Status;
            //this.newReceipt= item.Receipt?.Name || '';
            this.newSignature = item.reimbursement.EnteredBy;
            this.newManagerSignature = item.reimbursement.Manager;
            if (item.documents.length > 0) {
                const tempData = [];
                for (let i = 0; i < item.documents.length; i++) {
                    let fileExt = item.documents[i].AWSLink.split(".").pop();
                    tempData.push({
                        name: item.documents[i].Name,
                        id: item.documents[i]._id,
                        aws: item.documents[i].AWSLink,
                        ext: fileExt,
                    });
                }
                this.newReceipt = tempData;
            }
            this.AWSLink = this.newReceipt[0].aws;
        },

        updateReimbursement() {
            var req_body = {
                Date: this.newDate,
                Amount: this.newAmount,
                Type: this.newType,
                Balance: this.newBalance,
                Description: this.newDescription,
                Receipt: this.newReceipt,
                EnteredBy: this.newSignature,
                Manager: this.newManagerSignature,
                Status: this.status,
            };
            axios
                .put(`${url}/reimbursements/${this.reimbursementId}`, req_body)
                .then((response) => {
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            alert(data.msg);
                        });
                    }
                    this.msg = true;
                    this.text =
                        "The reimbursement has been updated successfully. Please refresh to see the updated data";

                    this.saveFile();
                });
            this.close();
        },

        addSignature: function () {
            if (this.signed === false) {
                this.newSignature = this.staff + " - " + new Date();
                this.signed = true;
            } else {
                this.newSignature = "";
                this.signed = false;
            }
        },
        addManagerSignature: function () {
            if (this.managerSigned === false) {
                this.newManagerSignature = this.staff + " - " + new Date();
                this.managerSigned = true;
            } else {
                this.newManagerSignature = "";
                this.managerSigned = false;
            }
        },

        fileSelected(e) {
            this.uploadFile = e;
        },

        saveFile() {
            this.message = "";
            for (let i = 0; i < this.uploadFile.length; i++) {
                this.uploadFiles(this.uploadFile[i]);
            }
        },

        uploadFiles(file) {
            const formData = new FormData();
            formData.append("reimbursement", file);
            var ct = {headers: {"content-type": "multipart/form-data"}};
            axios
                .post(
                    `${url}/reimbursements/fileuploader/${this.reimbursementId}/${this.employeeID}`,
                    formData,
                    ct
                )
                .then((res) => {
                    if (res) {
                        this.$router.go(-1);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        async generateDownloadUrl() {
            return `${url}/reimbursements/print-pdf?id=${this.reimbursementId}`;
        },

        async showPrint() {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(downloadUrl, this.reimbursementId, this.token, 'Reimbursement');
        },

        printTable() {
            window.print();
        },
    },
};
</script>
<style>
#print {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

@media print {
    #print {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;
    }

    nav.v-navigation-drawer,
    header.v-toolbar,
    button.v-btn,
    div.v-card {
        display: none;
        border: none;
    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }
}
</style>
